import classNames from 'classnames'
import React from 'react'

// Button instance for new design system (Voyage)
type ButtonProps = {
  size?: 'xl' | 'lg' | 'md' | 'sm',
  type?: 'primary' | 'primary-inverted' | 'secondary' | 'success' | 'outline' | 'text-link' | 'text-link-secondary' | 'warning'
  startIcon?: React.ReactNode,
  endIcon?: React.ReactNode,
  onClick?: () => void,
  label: string | React.ReactNode,
  opticalStart?: boolean,
  opticalEnd?: boolean,
  className?: string,
  rounded?: boolean,
  disabled?: boolean;
}

const Button = ({
  size = 'md',
  type = 'primary',
  startIcon,
  endIcon,
  onClick,
  label,
  opticalStart,
  opticalEnd,
  className,
  rounded = true,
  ...props
}: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={classNames(`move-btn move-btn--${size} move-btn--${type}`, {
        [`${className}`]: className,
        'rounded': rounded,
      })}
      {...props}
    >
      {opticalStart && <span />}
      {startIcon}
      <span>{label}</span>
      {endIcon}
      {opticalEnd && <span />}
    </button>
  )
}

export default Button
